import { render, staticRenderFns } from "./NewEconomicGroupForm.vue?vue&type=template&id=bca89bf8"
import script from "./NewEconomicGroupForm.vue?vue&type=script&lang=js"
export * from "./NewEconomicGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports